/* tempexp_18086-start */
import classNames from 'clsx';
import React from 'react';

import styles from './FeaturesList.css';
import { ReferralFeatures } from './FeaturesList.data';

const features = [
    ReferralFeatures.noads,
    ReferralFeatures.upload,
    ReferralFeatures.support,
    ReferralFeatures.family,
    ReferralFeatures.themePublic,
    ReferralFeatures.passwordPublic,
];

export function FeaturesList({ className }: { className?: string }) {
    return (
        <ul className={classNames(styles.root, className)}>
            {features.map((feature, index) => (
                <li key={index} className={styles.item}>
                    {feature}
                </li>
            ))}
        </ul>
    );
}

/* tempexp_18086-end */
